export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const nanoToMs = (timestamp?: string): number | null => {
  if (!timestamp) return null;
  const ms = Number(timestamp) / 1_000_000;
  return ms === 0 ? null : ms;
};
